import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LogoCompleta from "../../../assets/logonotify1.png";
import LogoIcone from "../../../assets/notifyicone.png";
import './Contas.css';
import PrivateMenuLeft from "../sections/Header/privateMenuLeft";
import PrivateMenuUp from "../sections/Header/privateMenuUp";
import useAuth from "../../../components/hooks/useAuth";
import Loader from "../../../components/Loader";
import AddLinkedZapModalComponent from "../LinkedZapDashBoard/Modals/add";


const HEADER_HEIGHT = 56;

const Contas = () => {
  const [showModal, setShowModal] = useState(false);
  const [linkedZapList, setLinkedZapList] = useState([]);
  const [loading, setLoading] = useState(false);

  const { sidebarOpen, getApi, postApi, deleteApi } = useAuth();

  const [novaConta, setNovaConta] = useState({ nome: "", telefone: "" });
  const navigate = useNavigate();

  const handleOpenModal = () => {
    setNovaConta({ nome: "", telefone: "" });
    setShowModal(true);
  };




  const handleCloseModal = () => setShowModal(false);

  const handleChangeNovaConta = (e) => {
    setNovaConta({ ...novaConta, [e.target.name]: e.target.value });
  };

  // Altere o handleCriarConta para redirecionar para a página de scan, passando só o nome
  const handleCriarConta = () => {
    setShowModal(false);
    navigate("/conectarconta", { state: { nome: novaConta.nome } });
  };

  // Detecta se está em mobile
  const isMobile = window.innerWidth <= 768;

  useEffect(() => {
    loadLinkedZap();
  }, []);

  const loadLinkedZap = async () => {
    setLoading(true);
    let response = await getApi("/api/v1/linkedZap/list", []);

    setLinkedZapList(response.lista);
    setLoading(false);
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <PrivateMenuLeft />
      <PrivateMenuUp />

      {/* Conteúdo da página de campanha */}
      <div
        style={{
          marginLeft: isMobile ? 56 : sidebarOpen ? 220 : 70,
          paddingTop: HEADER_HEIGHT,
          width: isMobile
            ? "calc(100vw - 56px)"
            : sidebarOpen
              ? "calc(100% - 220px)"
              : "calc(100% - 70px)",
          transition: "margin-left 0.3s, padding-top 0.3s, width 0.3s",
        }}
      >
        <div style={{ padding: 32 }}>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h2 style={{ fontWeight: "bold" }}>Minhas Contas</h2>
            <button
              type="button"
              className="btn btn-link"
              style={{ color: "#51a197", fontSize: 22, fontWeight: 600, textDecoration: "none" }}
              onClick={handleOpenModal}
              title="Adicionar conta"
            >
              <i className="bi bi-plus-circle"></i> <span className="d-none d-md-inline">Adicionar</span>
            </button>
          </div>


          <div style={{ display: "flex", flexWrap: "wrap", gap: 24, marginTop: 24 }}>
            {linkedZapList.map((linkedzap) => (
              <div key={linkedzap.id} className="card" style={{
                width: 320,
                borderRadius: 12,
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                background: "#fff",
                overflow: "hidden"

              }}
                onClick={e => navigate('/Contas/' + linkedzap.id)}>
                <div style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 24,
                  position: "relative"

                }}>
                  <span style={{
                    display: "inline-block",
                    width: 70,
                    height: 70,
                    borderRadius: "50%",
                    overflow: "hidden",
                    border: "3px solid #51a197",
                    background: "#eee",
                    position: "relative"

                  }}>
                    <img
                      src={linkedzap.profilePictureUrl ?? LogoIcone}
                      alt={linkedzap.name}

                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block"
                      }}
                    />
                    {/* Ícone verde pulsando */}
                    <span style={{
                      position: "absolute",
                      bottom: 6,
                      right: 6,
                      width: 32,
                      height: 32,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                      <span style={{
                        position: "absolute",
                        width: 32,
                        height: 32,
                        borderRadius: "50%",
                        background: "rgba(40, 199, 111, 0.3)",
                        animation: "pulse 1.2s infinite"
                      }}></span>
                      <span style={{
                        position: "relative",
                        width: 18,
                        height: 18,
                        borderRadius: "50%",
                        background: "#28c76f",
                        border: "3px solid #fff",
                        zIndex: 1
                      }}></span>
                    </span>
                  </span>
                </div>
                <div style={{ padding: 20, textAlign: "center" }}>
                  <h5 style={{ margin: 0, fontWeight: "bold" }}>{linkedzap.name}</h5>
                  <div style={{ color: "#888", marginTop: 6, fontSize: 15 }}>  {linkedzap.whatsapp_id}</div>
                </div>
              </div>
            ))}
          </div>
          {loading && <Loader />}
        </div>

        <AddLinkedZapModalComponent
          showModalAddLinkedZap={showModal}
          setShowModalAddLinkedZap={setShowModal}
          key={showModal}
        />
      </div>
      <style>
        {`
      @keyframes pulse {
        0% {
          transform: scale(0.8);
          opacity: 0.7;
        }
        70% {
          transform: scale(1.4);
          opacity: 0;
        }
        100% {
          transform: scale(0.8);
          opacity: 0;
        }
      }
      `}
      </style>
    </div >
  );
};

export default Contas;